import React from "react";
import { RangeColumnDefinition, RangeCriteria, RangeFilterChangeFunction, rangeFilter } from "./RangeColumnDefinition";
import { decimalComparator } from "@goodfill/sort";
import Decimal from "decimal.js";
import { DecimalRangeFilter, DecimalRangeFilterProps } from "../../../filters/DecimalRangeFilter";

export const decimalRangeFilter = <TCriteriaKey extends string, TItemKey extends string>(
  criteriaKey: TCriteriaKey,
  itemKey: TItemKey,
) => rangeFilter(criteriaKey, itemKey, decimalComparator);

export const DecimalRangeColumnDefinition = <
  TCriteriaKey extends string,
  TItemKey extends string,
  TRow extends {
    [key in TItemKey]: Decimal;
  },
>({
  name,
  itemKey,
  criteriaKey,
  criteria,
  onFilterChange,
  itemRenderer,
  width,
  rangeFilterProps,
}: {
  name: React.ReactNode;
  itemKey: TItemKey;
  criteriaKey: TCriteriaKey;
  criteria: RangeCriteria<TCriteriaKey, Decimal>;
  onFilterChange: RangeFilterChangeFunction<TCriteriaKey, Decimal>;
  itemRenderer: (item: TRow) => React.ReactNode;
  width?: number;
  rangeFilterProps?: Partial<Omit<DecimalRangeFilterProps, "onChange" | "value" | "small">>;
}) =>
  RangeColumnDefinition(
    name,
    itemKey,
    criteriaKey,
    criteria,
    onFilterChange,
    () => (
      <DecimalRangeFilter
        {...(rangeFilterProps ?? {})}
        small
        value={criteria[criteriaKey]}
        onChange={(value) => onFilterChange(criteriaKey, value)}
      />
    ),
    itemRenderer,
    width ?? 250,
  );
